<template>
  <div class="rfider-policy" v-if="entityName">
    <md-card class="md-card-unspaced rfider-policy-card rfider-shadow">
      <md-card-content>
        <div class="rfider-policy-card-content-rfider">
          <a class="rfider-policy-card-content-link"
            href="https://tradewindow.io/assure/"
            target="_blank"
            >{{ $t('shared.rfider_policy_rfider_info') }}
          </a>
        </div>
        <md-divider class="rfider-policy-card-content"></md-divider>

        <div v-if="showFull" class="rfider-policy-card-content-description">
          {{
            $t('shared.rfider_policy_rfider_description', { '0': entityName })
          }}
        </div>

        <div class="rfider-policy-card-content">
          <a
            class="rfider-policy-card-content-link"
            href="https://www.twassureplus.io/terms-of-use"
            target="_blank"
            >{{ $t('shared.terms_of_use') }}
          </a>
          -
          <a
            class="rfider-policy-card-content-link"
            href="https://tradewindow.io/legals/privacy-policy"
            target="_blank"
          >
            {{ $t('shared.privacy_policy', { '0': 'TradeWindow' }) }}</a
          >
          <span v-if="urlPrivacyPolicy">
            -
            <a
              class="rfider-policy-card-content-link"
              :href="urlPrivacyPolicy"
              target="_blank"
            >
              {{ $t('shared.privacy_policy', { '0': entityName }) }}</a
            >
          </span>
        </div>
        <div class="rfider-policy-card-content-id" v-if="debugCode">
          {{ debugCode }}
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
export default {
  props: {
    entityName: {
      type: String,
      required: false,
      default: '',
    },
    urlPrivacyPolicy: {
      type: String,
      required: false,
      default: '',
    },
    debugCode: {
      type: String,
      required: false,
    },
  },
  computed: {
    showFull: function () {
      return this.entityName.toLowerCase().indexOf('rfider') === -1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/shared/_rfider-policy.scss';
</style>
